// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"ContentWrapper_contentWrapper__EjVru"};